/* ============================================================
   RESILIA snapshot — interaction layer (v2)
   - bundle selector, FAQ accordion, countdown  (custom)
   - Swiper carousels + counter  (original theme behaviour restored)
   ============================================================ */
(function(){
  "use strict";
  function ready(fn){ if(document.readyState!=='loading') fn(); else document.addEventListener('DOMContentLoaded',fn); }

  /* ---------- BUNDLE SELECTORS ---------- */
  ready(function(){
    var sections = document.querySelectorAll('[id*="resilia_product_selector"]');
    if(!sections.length) sections = document.querySelectorAll('.shopify-section');
    sections.forEach(function(sec){
      var boxes = sec.querySelectorAll('.offer-box');
      if(!boxes.length) return;
      var priceEl   = sec.querySelector('.price-rows .price');
      var compareEl = sec.querySelector('.price-rows .compare-price');
      var saveEl    = sec.querySelector('.save-label [id^="sav-price"]') || sec.querySelector('.save-label span:last-child');
      var giftCallouts = sec.querySelectorAll('.pdp-main__offer-gift, .offer-gift-callout, [class*="offer-gift"]');
      function apply(box){
        boxes.forEach(function(x){ x.classList.remove('active'); });
        box.classList.add('active');
        var d = box.dataset;
        if(priceEl && d.perDeliveryPrice) priceEl.textContent = d.perDeliveryPrice;
        if(compareEl && d.effectiveComparePrice) compareEl.textContent = d.effectiveComparePrice;
        if(saveEl && d.savePrice) saveEl.textContent = d.savePrice;
        var tier = Array.prototype.indexOf.call(boxes, box) + 1;
        giftCallouts.forEach(function(g, gi){
          var min = parseInt(g.getAttribute('data-min')) || (gi+1);
          var locked = min > tier;
          g.classList.toggle('is-locked', locked);
          g.style.opacity = locked ? '0.4' : '';
          g.style.filter  = locked ? 'grayscale(1)' : '';
        });
      }
      boxes.forEach(function(box){ box.addEventListener('click', function(){ apply(box); }); });
      var init = sec.querySelector('.offer-box.active') || boxes[boxes.length-1];
      if(init) apply(init);
    });


    /* ---------- SIMPLE 3-OPTION BUY BOX (subscribe / one-time) ---------- */
    document.querySelectorAll('[data-np-buybox]').forEach(function(box){
      var opts = box.querySelectorAll('.np-opt');
      if(!opts.length) return;
      var atc = box.querySelector('[data-np-atc]');
      var renew = box.querySelector('[data-np-renew]');
      var toggle = box.querySelector('[data-np-toggle]');
      function selected(){ return box.querySelector('.np-opt.is-selected') || opts[0]; }
      function render(){
        var mode = box.getAttribute('data-mode') || 'sub';
        opts.forEach(function(x){
          var now = mode==='sub' ? x.dataset.sub : x.dataset.once;
          var was = x.dataset.was;
          var nowEl = x.querySelector('[data-now]'), wasEl = x.querySelector('[data-was]');
          if(nowEl) nowEl.textContent = '$'+now;
          if(wasEl){ wasEl.textContent = '$'+was; wasEl.style.display = (now===was) ? 'none' : ''; }
          var perEl = x.querySelector('[data-per]');
          if(perEl && x.dataset.bottles){ perEl.textContent = '$'+Math.round((mode==='sub'?+x.dataset.sub:+x.dataset.once)/(+x.dataset.bottles))+' per bottle'; }
        });
        var o = selected();
        if(atc) atc.setAttribute('href', mode==='sub' ? o.dataset.urlSub : o.dataset.urlOnce);
        if(renew){ if(mode==='sub'){ renew.textContent = o.dataset.renew || ''; renew.style.display=''; } else { renew.style.display='none'; } }
        if(toggle) toggle.textContent = mode==='sub' ? 'BUY ONCE - NO SAVINGS →' : 'SUBSCRIBE & SAVE →';
        var pnow=box.querySelector('[data-np-price]'), pwas=box.querySelector('[data-np-was]'), psave=box.querySelector('[data-np-save]');
        var nowV=(mode==='sub'?+o.dataset.sub:+o.dataset.once), wasV=+o.dataset.was, saveV=wasV-nowV;
        if(pnow) pnow.textContent='$'+nowV;
        if(pwas){ pwas.textContent='$'+wasV; pwas.style.display=saveV>0?'':'none'; }
        if(psave){ psave.textContent='SUMMER SALE - Save $'+saveV; psave.style.display=saveV>0?'':'none'; }
      }
      opts.forEach(function(o){ o.addEventListener('click', function(e){ e.preventDefault(); opts.forEach(function(x){ x.classList.remove('is-selected'); }); o.classList.add('is-selected'); render(); }); });
      if(toggle) toggle.addEventListener('click', function(){ box.setAttribute('data-mode', (box.getAttribute('data-mode')==='sub') ? 'once' : 'sub'); render(); });
      render();
    });

    /* ---------- FAQ ACCORDION ---------- */
    document.querySelectorAll('.faq-questions').forEach(function(q){
      var ans = q.nextElementSibling;
      if(!ans || !/faq-answers/.test(ans.className||'')) ans = q.parentElement.querySelector('.faq-answers');
      var icon = q.querySelector('.toggle-icons');
      q.addEventListener('click', function(e){
        e.preventDefault();
        var hidden = !ans || getComputedStyle(ans).display==='none' || ans.style.display==='none' || ans.style.display==='';
        if(ans){
          if(hidden){ ans.style.display='block'; q.classList.add('active'); q.parentElement.classList.add('active'); if(icon) icon.textContent='–'; }
          else { ans.style.display='none'; q.classList.remove('active'); q.parentElement.classList.remove('active'); if(icon) icon.textContent='+'; }
        }
      });
    });

    /* ---------- REAL BENEFITS accordion (.faq_question / .question_product) ---------- */
    (function(){
      var qs = document.querySelectorAll('.faq_question, .question_product');
      if(!qs.length) return;
      function hide(a){ if(a) a.style.setProperty('display','none','important'); }
      function show(a){ if(a) a.style.setProperty('display','flex','important'); }
      // collapse all answers by default (CSS forces flex !important, so override with !important)
      qs.forEach(function(q){ hide(q.nextElementSibling); q.classList.remove('active'); });
      document.addEventListener('click', function(e){
        var q = e.target.closest('.faq_question, .question_product');
        if(!q) return;
        e.preventDefault();
        var a = q.nextElementSibling;
        if(q.classList.contains('active')){
          q.classList.remove('active'); hide(a);
        } else {
          document.querySelectorAll('.faq_question.active, .question_product.active').forEach(function(o){
            o.classList.remove('active'); hide(o.nextElementSibling);
          });
          q.classList.add('active'); show(a);
        }
      });
    })();

    /* ---------- COUNTDOWN TIMER ---------- */
    (function(){
      var groups = [];
      document.querySelectorAll('[class*="countdown"],[id*="countdown"],[class*="timer"],[id*="replo_countdown"]').forEach(function(c){
        var digits = [].filter.call(c.querySelectorAll('*'), function(e){ return e.childElementCount===0 && /^\s*\d{1,2}\s*$/.test(e.textContent); });
        if(digits.length>=3) groups.push(digits.slice(0,3));
      });
      if(!groups.length){
        document.querySelectorAll('*').forEach(function(c){
          if(!/Hrs/.test(c.textContent) || c.children.length>12) return;
          var digits=[].filter.call(c.querySelectorAll('*'),function(e){return e.childElementCount===0 && /^\s*\d{2}\s*$/.test(e.textContent);});
          if(digits.length>=3 && groups.length<4) groups.push(digits.slice(0,3));
        });
      }
      if(!groups.length) return;
      var total = (parseInt(groups[0][0].textContent)||0)*3600 + (parseInt(groups[0][1].textContent)||0)*60 + (parseInt(groups[0][2].textContent)||0);
      if(total<=0) total = 2*3600;
      function pad(n){ return ('0'+n).slice(-2); }
      function tick(){
        var h=Math.floor(total/3600), m=Math.floor((total%3600)/60), s=total%60;
        groups.forEach(function(g){ g[0].textContent=pad(h); g[1].textContent=pad(m); g[2].textContent=pad(s); });
        total = total<=0 ? (2*3600) : total-1;
      }
      tick(); setInterval(tick,1000);
    })();
  });

  /* ---------- SWIPER: loader + shim + cleanup + gallery ---------- */
  var _queue = [];
  window.ResiliaSwiper = window.ResiliaSwiper || {};
  window.ResiliaSwiper.run = function(cb){ if(window.Swiper){ try{cb(window.Swiper);}catch(e){console.warn(e);} } else { _queue.push(cb); } };

  function cleanStaleSwipers(){
    document.querySelectorAll('.swiper-slide-duplicate').forEach(function(s){ s.remove(); });
    document.querySelectorAll('.swiper-initialized').forEach(function(e){ e.classList.remove('swiper-initialized','swiper-backface-hidden'); });
    document.querySelectorAll('.swiper-wrapper').forEach(function(w){ w.removeAttribute('style'); });
    document.querySelectorAll('.swiper-slide').forEach(function(s){ s.style.width=''; s.style.marginRight=''; s.style.transform=''; });
    document.querySelectorAll('.swiper-pagination').forEach(function(p){ p.innerHTML=''; });
  }

  function initGallery(Swiper){
    document.querySelectorAll('.product-swiper-main').forEach(function(mainEl){
      if(mainEl.swiper) return;
      var wrap = mainEl.closest('.product-image') || mainEl.parentElement;
      var thumbEl = wrap.querySelector('.product-swiper-thumbs');
      var thumbs = null;
      if(thumbEl && !thumbEl.swiper){
        thumbs = new Swiper(thumbEl, { slidesPerView:'auto', spaceBetween:10, watchSlidesProgress:true, freeMode:true });
      }
      var cfg = { slidesPerView:1, spaceBetween:12, loop:false, watchOverflow:true,
        navigation:{ prevEl: wrap.querySelector('.swiper-thumb-prev'), nextEl: wrap.querySelector('.swiper-thumb-next') } };
      if(thumbs) cfg.thumbs = { swiper: thumbs };
      var mainSwiper = new Swiper(mainEl, cfg);
      // explicit thumb click -> main slide + active highlight (robust across Swiper builds)
      if(thumbEl){
        var tslides = thumbEl.querySelectorAll('.swiper-slide');
        [].forEach.call(tslides, function(ts, i){
          ts.addEventListener('click', function(){ mainSwiper.slideTo(i); });
        });
        function syncActive(){
          [].forEach.call(tslides, function(ts, i){ ts.classList.toggle('swiper-slide-thumb-active', i===mainSwiper.activeIndex); });
        }
        mainSwiper.on('slideChange', syncActive); syncActive();
      }
    });
  }

  function _upFind(el,sel){ var n=el; for(var i=0;i<6&&n;i++){ var f=n.querySelector&&n.querySelector(sel); if(f) return f; n=n.parentElement; } return null; }

  function initOoVt(Swiper){
    document.querySelectorAll('.oo-vt-swiper').forEach(function(el){
      if(el.swiper) return;
      new Swiper(el, {
        slidesPerView: 3, spaceBetween: 16, loop: true, watchOverflow: true,
        navigation:{ prevEl: _upFind(el.parentElement,'.oo-vt-prev'), nextEl: _upFind(el.parentElement,'.oo-vt-next') },
        breakpoints:{ 0:{ slidesPerView:1.15, spaceBetween:12 }, 768:{ slidesPerView:3, spaceBetween:16 } }
      });
    });
  }

  function onSwiperReady(){
    try{ cleanStaleSwipers(); }catch(e){ console.warn(e); }
    try{ initGallery(window.Swiper); }catch(e){ console.warn(e); }
    try{ initOoVt(window.Swiper); }catch(e){ console.warn(e); }
    var q=_queue.slice(); _queue.length=0;
    q.forEach(function(cb){ try{ cb(window.Swiper); }catch(e){ console.warn(e); } });
  }

  function boot(){
    if(window.Swiper){ onSwiperReady(); return; }
    var s=document.createElement('script');
    s.src='https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
    s.onload=onSwiperReady;
    s.onerror=function(){
      var f=document.createElement('script');
      f.src='https://unpkg.com/swiper@11/swiper-bundle.min.js';
      f.onload=onSwiperReady; document.head.appendChild(f);
    };
    document.head.appendChild(s);
  }
  ready(boot);
})();

/* ===== original: reviews slider (s143) ===== */

window.ResiliaSwiper.run((Swiper) => {
(function () {
  var sectionId = 'template--28322335555768__testimonial_slider_FMJeXK';

  function initSliders() {
    var sectionEl = document.querySelector('#shopify-section-' + sectionId);
    if (!sectionEl) return;

    var reviewEl = sectionEl.querySelector('#ts-review-' + sectionId);

    if (reviewEl && reviewEl.swiper) reviewEl.swiper.destroy(true, true);

    if (reviewEl) {      new Swiper(reviewEl, {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        navigation: {
          nextEl: sectionEl.querySelector('.ts-next-' + sectionId),
          prevEl: sectionEl.querySelector('.ts-prev-' + sectionId),
        },
        pagination: {
          el: sectionEl.querySelector('.ts-pagination-' + sectionId),
          clickable: true,
        },
        breakpoints: {
          768: {
            slidesPerView: 3,
          }
        }
      });
    }
  }

  function initMarquee() {
    var sectionEl = document.querySelector('#shopify-section-' + sectionId);
    if (!sectionEl) return;
    var track = sectionEl.querySelector('.ts-marquee-track');
    if (!track || !track.children.length) return;

    // Liquid outputs 2 copies; use the first half as the original set
    var allItems = Array.from(track.children);
    var origLen = Math.floor(allItems.length / 2);
    if (origLen < 1) return;
    var origItems = allItems.slice(0, origLen);

    // Clone sets until the track is at least 2× the viewport wide (prevents visible gap)
    var safety = 30;
    while (track.scrollWidth < window.innerWidth * 2 && safety-- > 0) {
      origItems.forEach(function (item) {
        track.appendChild(item.cloneNode(true));
      });
    }

    // Recalculate the correct translation: one set / total track = 1/N of 100%
    var totalSets = track.children.length / origLen;
    track.style.setProperty('--marquee-end', '-' + (100 / totalSets).toFixed(4) + '%');
  }

  initSliders();
  initMarquee();

  document.addEventListener('shopify:section:load', function (e) {
    if (e.detail.sectionId === sectionId) {
      initSliders();
      initMarquee();
    }
  });
})();
});

/* ===== original: reasons slider (s147) ===== */

window.ResiliaSwiper.run((Swiper) => {
(function () {
  var sectionId = 'template--28322335555768__resilia_reasons_QzYcj3';

  function initBenefitsSwiper() {
    var el = document.querySelector('#benefits-swiper-' + sectionId);
    if (!el) return;
    if (el.swiper) el.swiper.destroy(true, true);

    new Swiper(el, {
      slidesPerView: 1,
      spaceBetween: 12,
      loop: true,
      navigation: {
        prevEl: document.querySelector('.benefits-prev-' + sectionId),
        nextEl: document.querySelector('.benefits-next-' + sectionId),
      },
      pagination: {
        el: document.querySelector('.benefits-pagination-' + sectionId),
        clickable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 4,
          spaceBetween: 12,
        }
      }
    });
  }

  initBenefitsSwiper();

  document.addEventListener('shopify:section:load', function (e) {
    if (e.detail.sectionId === sectionId) initBenefitsSwiper();
  });
})();
});

/* ===== 9 oils compounds slider (pagination + arrows, like reasons) ===== */
window.ResiliaSwiper.run(function (Swiper) {
  function initCompoundsSwiper() {
    var el = document.querySelector('#compounds-swiper');
    if (!el) return;
    if (el.swiper) el.swiper.destroy(true, true);
    new Swiper(el, {
      slidesPerView: 1.15,
      spaceBetween: 16,
      watchOverflow: true,
      navigation: {
        prevEl: document.querySelector('.compounds-prev'),
        nextEl: document.querySelector('.compounds-next'),
      },
      pagination: {
        el: document.querySelector('.compounds-pagination'),
        clickable: true,
      },
      breakpoints: {
        640: { slidesPerView: 2, spaceBetween: 16 },
        768: { slidesPerView: 4, spaceBetween: 24 }
      }
    });
  }
  initCompoundsSwiper();
});

/* ===== original: video testimonial slider (s149) ===== */

window.ResiliaSwiper.run((Swiper) => {
  var isIndex = false;

  new Swiper('.testimonial-swiper-template--28322335555768__testimonial_slider_1_JAxMBk', {
    slidesPerView: isIndex ? 5 : 6,
    slidesPerGroup: isIndex ? 1 : 2,
    spaceBetween: 0,
    loop: true,
    dots: true,
    pagination: {
      el: '.testimonial-swiper-template--28322335555768__testimonial_slider_1_JAxMBk .vt-pagination',
      clickable: true,
    },
    navigation: {
      prevEl: '.testimonial-swiper-template--28322335555768__testimonial_slider_1_JAxMBk',
      nextEl: '.testimonial-swiper-template--28322335555768__testimonial_slider_1_JAxMBk',
    },
    breakpoints: {
      0: {
        slidesPerView: isIndex ? 1 : 3,
        slidesPerGroup: 1,
      },
      768: {
        slidesPerView: isIndex ? 1 : 3,
        slidesPerGroup: 1,
      },
      1024: {
        slidesPerView: isIndex ? 4 : 4,
        slidesPerGroup: isIndex ? 1 : 2,
      },
      1200: {
        slidesPerView: isIndex ? 5 : 6,
        slidesPerGroup: isIndex ? 1 : 2,
      },
    },
    on: {
      init: function (swiper) {
        document.querySelector('.testimonial-swiper-template--28322335555768__testimonial_slider_1_JAxMBk')
          .closest('.testimonial-slider-wrapper')
          .querySelector('.vt-prev').addEventListener('click', function () {
            swiper.slidePrev();
          });
        document.querySelector('.testimonial-swiper-template--28322335555768__testimonial_slider_1_JAxMBk')
          .closest('.testimonial-slider-wrapper')
          .querySelector('.vt-next').addEventListener('click', function () {
            swiper.slideNext();
          });
      }
    }
  });

  // Play/pause logic
  document.body.addEventListener('click', function (e) {
    const btn = e.target.closest('.custom-play-button');
    if (!btn) return;
    const wrapper = btn.closest('.video-wrapper');
    const video = wrapper ? wrapper.querySelector('video') : null;
    if (video) {
      document.querySelectorAll('video').forEach(function (v) {
        if (v !== video) {
          v.pause();
          v.controls = false;
          const otherBtn = v.parentElement.querySelector('.custom-play-button');
          if (otherBtn) otherBtn.style.display = 'block';
        }
      });
      video.play();
      video.controls = true;
      btn.style.display = 'none';
      video.onpause = function () {
        btn.style.display = 'block';
        video.controls = false;
      };
    }
  });
});

/* ===== original: compounds carousel (s141) ===== */

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.compounds-section').forEach(function (section) {
    const track = section.querySelector('.compounds-carousel-track');
    const slides = section.querySelectorAll('.compounds-carousel-slide');
    const prevBtn = section.querySelector('.compounds-nav-prev');
    const nextBtn = section.querySelector('.compounds-nav-next');

    if (!track || !slides.length || !prevBtn || !nextBtn) return;

    let currentIndex = 0;
    const slideWidthPercent = 85;
    const gapPx = 16;

    function updateCarousel() {
      track.style.transform =
        `translateX(calc(-${currentIndex} * (${slideWidthPercent}% + ${gapPx}px)))`;
    }

    prevBtn.addEventListener('click', function () {
      currentIndex = currentIndex === 0
        ? slides.length - 1
        : currentIndex - 1;
      updateCarousel();
    });

    nextBtn.addEventListener('click', function () {
      currentIndex = currentIndex === slides.length - 1
        ? 0
        : currentIndex + 1;
      updateCarousel();
    });
  });
});


/* ===== original: stat counter (s140) ===== */

document.addEventListener("DOMContentLoaded", function () {
  const section = document.querySelector('.clinical-proven-section');

  const options = { threshold: 0.3 };

  const parseStatTarget = (el) => {
    const raw = (el.getAttribute('data-target') || '').trim();
    const match = raw.match(/^(\D*)([\d.,\s]+)(.*)$/);
    if (!match) return null;
    const prefix = match[1] || '';
    const numericStr = match[2].replace(/[\s,]/g, '');
    const userSuffix = match[3] || '';
    const hasDecimal = numericStr.includes('.');
    const target = hasDecimal ? parseFloat(numericStr) : parseInt(numericStr, 10);
    if (isNaN(target)) return null;
    const hasCustomText = prefix.length > 0 || userSuffix.length > 0;
    const autoPct = el.getAttribute('data-hide-percent') === 'true' ? '' : '%';
    const suffix = hasCustomText ? userSuffix : autoPct;
    const decimals = hasDecimal ? (numericStr.split('.')[1] || '').length : 0;
    const formatValue = (val) => {
      if (decimals > 0) {
        return val.toLocaleString('en-US', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
      }
      return Math.round(val).toLocaleString('en-US');
    };
    return { prefix, target, suffix, formatValue };
  };

  document.querySelectorAll('.clinical-proven-section .stat-percentage').forEach(el => {
    const parsed = parseStatTarget(el);
    if (!parsed) return;
    el.textContent = parsed.prefix + parsed.formatValue(0) + parsed.suffix;
  });

  const animateStat = (el) => {
    const parsed = parseStatTarget(el);
    if (!parsed) return;
    const { prefix, target, suffix, formatValue } = parsed;
    const duration = target <= 100 ? 1000 : 1800;
    const startTime = performance.now();
    const easeOutQuad = (t) => 1 - (1 - t) * (1 - t);
    const update = (now) => {
      const progress = Math.min((now - startTime) / duration, 1);
      el.textContent = prefix + formatValue(easeOutQuad(progress) * target) + suffix;
      if (progress < 1) requestAnimationFrame(update);
      else el.textContent = prefix + formatValue(target) + suffix;
    };
    requestAnimationFrame(update);
  };

  const animateCardNumber = (el) => {
    const target = parseInt(el.getAttribute('data-target'), 10);
    if (isNaN(target)) return;
    const duration = 4000;
    const startTime = performance.now();
    const easeInOutSine = (t) => -(Math.cos(Math.PI * t) - 1) / 2;
    const update = (now) => {
      const progress = Math.min((now - startTime) / duration, 1);
      el.textContent = Math.round(easeInOutSine(progress) * target);
      if (progress < 1) requestAnimationFrame(update);
      else el.textContent = target;
    };
    requestAnimationFrame(update);
  };

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        section.querySelectorAll('.stat-percentage').forEach(el => {
          if (!el.classList.contains('counted')) {
            el.classList.add('counted');
            animateStat(el);
          }
        });
        section.querySelectorAll('.card-number[data-target]').forEach(el => {
          if (!el.classList.contains('counted')) {
            el.classList.add('counted');
            animateCardNumber(el);
          }
        });
        obs.unobserve(entry.target);
      }
    });
  }, options);

  if (section) observer.observe(section);
});

/* ===== HLS playback for review videos (Shopify c/vp .m3u8 renditions) =====
   Sources use type="application/x-mpegURL". iOS/macOS Safari play them natively
   from <source>. Other browsers get hls.js, attached lazily as each video nears
   the viewport so mobile loads only the light SD segment (not the 75MB original). */
(function () {
  function setup() {
    var sources = document.querySelectorAll('video source[type="application/x-mpegURL"]');
    if (!sources.length) return;
    // Prefer hls.js wherever Media Source Extensions exist (Chrome/Firefox/Edge/Android
    // and desktop Safari). iOS Safari has no window.MediaSource, so it falls through and
    // plays the <source> HLS natively — no JS needed. (canPlayType is unreliable: some
    // Chromium builds falsely report native HLS support and then never load the stream.)
    if (!('MediaSource' in window)) return;

    var videos = [];
    sources.forEach(function (s) { if (videos.indexOf(s.parentElement) === -1) videos.push(s.parentElement); });

    var HlsLib = null, loading = false, waiters = [];
    function ensureLib(cb) {
      if (HlsLib) { cb(); return; }
      waiters.push(cb);
      if (loading) return; loading = true;
      var s = document.createElement('script');
      s.src = 'https://cdn.jsdelivr.net/npm/hls.js@1/dist/hls.min.js';
      s.onload = function () {
        if (window.Hls && window.Hls.isSupported()) {
          HlsLib = window.Hls;
          waiters.forEach(function (f) { f(); }); waiters = [];
        }
      };
      document.head.appendChild(s);
    }
    function attach(video) {
      if (video.__hlsAttached) return;
      var src = video.querySelector('source[type="application/x-mpegURL"]');
      if (!src) return;
      video.__hlsAttached = true;
      var hls = new HlsLib({ capLevelToPlayerSize: true, startLevel: 0, maxBufferLength: 8 });
      hls.loadSource(src.getAttribute('src'));
      hls.attachMedia(video);
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { var v = e.target; io.unobserve(v); ensureLib(function () { attach(v); }); }
        });
      }, { rootMargin: '400px' });
      videos.forEach(function (v) { io.observe(v); });
    } else {
      ensureLib(function () { videos.forEach(attach); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
})();
